// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"974846d2","488":"f4d705dc","777":"4c691923"}[chunkId] + ".chunk.js";
};